module.exports = __webpack_public_path__ + "img/right_normal.e36f2bbf.png";